import React, { useEffect, useRef, useState } from 'react';
import OnlineSearchBiddingForm from 'components/molecules/online_search_bidding_form';
import { useDispatch, useSelector } from 'react-redux';
import { BiddingState, BiddingTypes } from 'store/modules/bidding_store/types';
import { ApplicationState } from 'store';
import { ProfileState } from 'store/modules/profile_store/types';
import BlockedSubscription from 'components/molecules/blocked_subscription';
import { OnlineSearchState, OnlineSearchTypes } from 'store/modules/online_search_store/types';
import BiddingList from 'components/organisms/bidding_list';
import { getBiddings } from 'store/modules/bidding_store/actions';
import tabId from 'services/tabId';
import BlockedSubscriptionRepresentant from 'components/molecules/blocked_subscription_representant';
import { ActivitiesState } from 'store/modules/activities_store/types';
import { fetchActivities } from 'store/modules/activities_store/actions';

const BiddingOnlineSearch = () => {
  const dispatch = useDispatch();

  const allowedSaleSituations = ['Ativa', 'Em Analise'];

  const { profile } = useSelector<ApplicationState, ProfileState>((state) => state.storage.profile);
  const { request } = useSelector<ApplicationState, BiddingState>(
    (state) => state.session.biddings,
  );

  const { onlineSearch } = useSelector<ApplicationState, OnlineSearchState>(
    (state) => state.session.onlineSearch,
  );
  const { activities } = useSelector<ApplicationState, ActivitiesState>(
    (state) => state.storage.activities,
  );

  const [searchBarOpened, setSearchBarOpened] = useState<boolean>(true);
  const [currentCompany, setCurrentCompany] = useState<number>(
    profile.currentCompany[tabId()] || profile.clientId,
  );

  const fetchAllActivities = () => {
    if (profile?.representant) {
      const missingActivities = profile?.represented?.find((company) => {
        if (!activities[company.id.toString()]) return company;
        if (activities[company.id.toString()].length === 0) return company;
        return false;
      });
      if (missingActivities) dispatch(fetchActivities());
    }

    if (!profile?.representant) {
      if (
        !activities[profile.clientId.toString()] ||
        activities[profile.clientId.toString()].length === 0
      )
        dispatch(fetchActivities());
    }
  };

  const fetchBiddings = () => {
    if (profile.representant && profile.currentCompany[tabId()] !== profile.company_data.data.id) {
      dispatch(
        getBiddings(
          {
            activities_list: activities[profile.currentCompany[tabId()]],
            filters: onlineSearch.filters,
            page: onlineSearch.currentPage,
            per_page: onlineSearch.postsPerPage,
            order: onlineSearch.orderedBy || null,
            order_direction: onlineSearch.orderedBy ? onlineSearch.orderDirection : null,
          },
          profile.currentCompany[tabId()],
        ),
      );
      return;
    }
    dispatch(
      getBiddings({
        activities_list: activities[profile.currentCompany[tabId()]],
        filters: onlineSearch.filters,
        page: onlineSearch.currentPage,
        per_page: onlineSearch.postsPerPage,
        order: onlineSearch.orderedBy || null,
        order_direction: onlineSearch.orderedBy ? onlineSearch.orderDirection : null,
      }),
    );
  };

  useEffect(() => {
    fetchAllActivities();
  }, []);

  useEffect(() => {
    setCurrentCompany(profile.currentCompany[tabId()]);
  }, [profile.currentCompany[tabId()]]);

  useEffect(() => {
    document.title = 'Encontrar Licitações - ConLicitação';

    dispatch({ type: BiddingTypes.UPDATE_STORE_FIELDS });
    dispatch({ type: OnlineSearchTypes.UPDATE_STORE_FIELDS });

    onlineSearch?.state_from_panel?.length === 0 && fetchBiddings();
  }, [currentCompany]);

  useEffect(() => {
    if (onlineSearch.currentPage === 1 && onlineSearch.filters.updated) {
      fetchBiddings();
    }
    if (onlineSearch?.state_from_panel?.length === 0) {
      if (onlineSearch.filters.updated)
        dispatch({ type: OnlineSearchTypes.UPDATE_CURRENT_PAGE, currentPage: 1 });
    }
  }, [onlineSearch.filters.updated]);

  useEffect(() => {
    if (request?.get_biddings?.loading) return;
    onlineSearch?.state_from_panel?.length === 0 && fetchBiddings();
  }, [onlineSearch.currentPage]);

  useEffect(() => {
    if (request?.get_biddings?.loading) return;

    onlineSearch?.state_from_panel?.length === 0 && fetchBiddings();
  }, [onlineSearch.postsPerPage]);

  const orderMountedRef = useRef(false);
  useEffect(() => {
    if (!orderMountedRef.current) {
      orderMountedRef.current = true;
      return;
    }

    if (request?.get_biddings?.loading) return;
    if (onlineSearch?.state_from_panel?.length !== 0) return;

    if (onlineSearch.currentPage !== 1) {
      dispatch({ type: OnlineSearchTypes.UPDATE_CURRENT_PAGE, currentPage: 1 });
      return;
    }

    fetchBiddings();
  }, [onlineSearch.orderedBy, onlineSearch.orderDirection]);

  return (
    <div className="page-container">
      {profile.representant &&
        profile.paralyzed &&
        profile.currentCompany[tabId()] === profile.clientId && (
          <BlockedSubscription paralyzed={profile.paralyzed} />
        )}
      {!profile.representant &&
        allowedSaleSituations.includes(profile.sale_situation) &&
        !profile.paralyzed && (
          <>
            <OnlineSearchBiddingForm
              searchBarOpened={searchBarOpened}
              setSearchBarOpened={setSearchBarOpened}
            />
            <BiddingList searchBarOpened={searchBarOpened} />
          </>
        )}
      {!profile.representant &&
        profile.paralyzed &&
        allowedSaleSituations.includes(profile.sale_situation) && (
          <BlockedSubscription paralyzed={profile.paralyzed} />
        )}
      {!profile.representant && !allowedSaleSituations.includes(profile.sale_situation) && (
        <BlockedSubscription paralyzed={profile.paralyzed} />
      )}
      {profile.representant &&
        allowedSaleSituations.includes(
          profile?.represented?.filter(
            (company) => company.id === profile.currentCompany[tabId()],
          )[0]?.sale_situation_name,
        ) &&
        !profile.represented.filter((company) => company.id === profile.currentCompany[tabId()])[0]
          ?.paralisado && (
          <>
            <OnlineSearchBiddingForm
              searchBarOpened={searchBarOpened}
              setSearchBarOpened={setSearchBarOpened}
            />
            <BiddingList searchBarOpened={searchBarOpened} />
          </>
        )}
      {profile.representant &&
        profile.currentCompany[tabId()] !== profile.clientId &&
        profile.represented.filter((company) => company.id === profile.currentCompany[tabId()])[0]
          ?.paralisado &&
        allowedSaleSituations.includes(
          profile?.represented?.filter(
            (company) => company.id === profile.currentCompany[tabId()],
          )[0]?.sale_situation_name,
        ) && <BlockedSubscriptionRepresentant />}
      {profile.representant &&
        profile.currentCompany[tabId()] !== profile.clientId &&
        !allowedSaleSituations.includes(
          profile?.represented?.filter(
            (company) => company.id === profile.currentCompany[tabId()],
          )[0]?.sale_situation_name,
        ) && <BlockedSubscriptionRepresentant />}
    </div>
  );
};

export default BiddingOnlineSearch;
